// noinspection ES6CheckImport

import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';
import {getAuth} from "firebase/auth";
import {getFunctions} from "firebase/functions";
import {getMessaging} from "firebase/messaging";
import {getStorage} from "firebase/storage";
import {getStripePayments} from "@invertase/firestore-stripe-payments";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

const app = initializeApp(firebaseConfig)

const firestore = getFirestore(app)
const auth = getAuth(app)
const functions = getFunctions(app)
const messaging = getMessaging(app)
const storage = getStorage(app)

// if (process.env.NODE_ENV !== 'production') {
//   // Set up emulators
//   connectFirestoreEmulator(firestore, 'localhost', 8080)
//   connectAuthEmulator(auth, 'http://localhost:9099')
//   connectFunctionsEmulator(functions, "localhost", 5001)
// }

const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "users",
});

export default app;

export {
  firebaseConfig,
  auth,
  firestore,
  functions,
  messaging,
  storage,
  payments
};
